app.controller('action_planController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $controller, $window) {

	//Include custom controller functionality
	$controller('userDefinedActionPlanController', {$scope: $scope, $stateParams: $stateParams});
	
	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	$scope.action_plan_details = {'display_message':false, 'id': true, 'details':{}};

	$scope.default_tab_select = 'create_tab';

	if(typeof($scope['appState']) != 'undefined')
	{
		if(typeof($scope['appState']['submit_time_value']) != 'undefined' && $scope['appState']['submit_time_value'] != '')
		{
			if(typeof($scope['appState']['admin_site_superset_value']) != 'undefined' && $scope['appState']['admin_site_superset_value'] != '')
			{
				var actionParams = {};
				actionParams.admin_site_id = $scope['appState']['admin_site_superset_value'];
				actionParams.time_period = $scope['appState']['submit_time_value'];
				actionParams.survey_key = $scope['appState']['submenu_key'];

				$scope.action_plan_doc_download_url = $location.absUrl().split('#')[0]+'/common/document_download';

				angular.forEach($scope['filters']['admin_site']['value']['superset']['value'], function(value, key){
					if(value.id == $scope['appState']['admin_site_superset_value'])
					{
						$scope.selected_dealer_name = value.label;
						return false;
					}
				});

				if(typeof($scope['filters']['submit_time']['value'][$scope['appState']['submit_time']]) != 'undefined')
				{
					if(typeof($scope['filters']['submit_time']['value'][$scope['appState']['submit_time']]['value'][actionParams.time_period]) != 'undefined')
					{
						var time_obj = $scope['filters']['submit_time']['value'][$scope['appState']['submit_time']]['value'][actionParams.time_period];
						$scope.current_time_period_obj = time_obj;
						actionParams.from_time = time_obj.from;
						actionParams.to_time = time_obj.to;
					}
				}


				dataService.getData('action_plan/get_actn_plan_details', actionParams, 'POST')
				.then(function(response) {
					if(typeof(response.data) != 'undefined')
					{
						$scope.action_plan_details = response.data;
						
						//redirect to current tab based on action status
						$scope.changeTabSelection();
						//end of redirect to current tab based on action status
						
					}
					
				})
			}

			//initialise filters
			var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
			
			if(filtersLoaded)
			{	
				//initialise components
				pageHandler.initComponents(pageConfig, $scope);
			
				//show loading on components
				pageHandler.showLoading(pageConfig, $scope);
			
				//request data for components
				pageHandler.requestDataForComponents(pageConfig, $scope);
				
				//initialize export feature
				pageHandler.initPageExports(pageConfig, $scope);

				$scope.requiredData = [];
			}
		}

	}

	$scope.changeTabSelection = function()
	{
		var tab_selection = {'0':'create_tab', '1':'action_tab', '2':'action_tab', '3':'complete_tab'};
		var tab_filter = '';
		if(typeof($scope.action_plan_details) != 'undefined' && $scope.action_plan_details != null && $scope.action_plan_details != '')
		{
			if(typeof(tab_selection) != 'undefined')
			{
				if(typeof($scope.appState.page) != 'undefined')
				{
					if(typeof($scope.page_filters) != 'undefined')
					{
						//console.log($scope.page_filters[$scope.appState.page][$scope.appState.submenu_key]);
						if(typeof($scope.page_filters[$scope.appState.page]) != 'undefined' && typeof($scope.page_filters[$scope.appState.page][$scope.appState.submenu_key]) != 'undefined')
						{
							var app_page_filter = $scope.page_filters[$scope.appState.page][$scope.appState.submenu_key];

							angular.forEach(app_page_filter, function(filter_value, filter_key){
								if(typeof(filter_value.filter_type) != 'undefined' && filter_value.filter_type == 'tab')
								{
									tab_filter = filter_key;
									return false;
								}
							});
						}
					}
				}

				if(tab_filter != '')
				{
					if($scope.action_plan_details.action == null)
					{
						$scope[tab_filter]['selected_value'] = tab_selection[0];
						$scope['appState']['page_filters'][tab_filter] = tab_selection[0];
					}
					else
					{
						angular.forEach(tab_selection, function(value, key){
							if(key == $scope.action_plan_details.action)
							{
								$scope.default_tab_select = value;
								$scope[tab_filter]['selected_value'] = value;
								$scope['appState']['page_filters'][tab_filter] = value;
								return false;
							}
						});
					}
				}
			}
		}
	}

	$scope.record_action_plan = function($action)
	{
		var survey_key = $scope.appState.submenu_key;
		var form_data = new FormData(document.querySelector('#actionPlanForm'));//$('#actionPlanForm').serialize();
		var new_form_data = new FormData();

		var atleast_one = {};
		var other_value_validation = {};
		var validation_failed = {};
		var atleast_one_error_message = '';
		new_form_data.append('action', $action);
		new_form_data.append('admin_site_id', $scope['appState']['admin_site_superset_value']);
		new_form_data.append('time_period', $scope['appState']['submit_time_value']);
		new_form_data.append('survey_key', $scope['appState']['submenu_key']);
		new_form_data.append('from_time', $scope['current_time_period_obj']['from']);
		new_form_data.append('to_time', $scope['current_time_period_obj']['to']);

		var _file_extension = [];
		var _file_size = '';

		if(typeof($scope['action_plan_details']['file_validation']) != 'undefined')
		{
			if(typeof($scope['action_plan_details']['file_validation']['extension']) != 'undefined')
			{
				_file_extension = $scope['action_plan_details']['file_validation']['extension'];
			}
			if(typeof($scope['action_plan_details']['file_validation']['file_size']) != 'undefined')
			{
				_file_size = $scope['action_plan_details']['file_validation']['file_size'];
			}
		}

		$('#actionPlanForm *').filter(':input', ':select', ':textarea').each(function(){

			if($(this).attr('type') == 'hidden' && $(this).attr('name') == 'plan_id_'+survey_key){
				new_form_data.append('plan_id', $(this).val());
			}

			if($(this).attr('type') == 'checkbox'){
				var current_value = $(this).val();
				var current_validation = {};
				angular.forEach($scope.validationAttributes, function(value, key){
					if(value.type == 'checkbox' && value.id == current_value)
					{
						current_validation = value;
						return false;//break
					}
				});
					
				//check
				if(current_validation['required'] == "at_least_one")
				{
					atleast_one_error_message = current_validation['error_message'];
					if(!(current_validation.element_name in atleast_one)){
						atleast_one[current_validation.element_name] = [];
					}
				}

				if($(this).prop("checked")){
					atleast_one[current_validation.element_name].push($(this).val());

					if(current_validation['other_value_exist'] == true)
					{
						if((current_validation.element_name in atleast_one) && atleast_one[current_validation.element_name].length > 0){
							angular.forEach(atleast_one[current_validation.element_name], function(value, key){
								if(value == current_validation['other_value'])
								{
									other_value_validation[current_validation.other_value_element] = current_validation;
									return false;//break
								}
							});
						}
					}

					//Check other validations like other

					new_form_data.append(current_validation.element_name+'_'+$(this).val(), $(this).val());
				}				


			}

			if($(this).attr('type') == 'textbox'){
				var current_obj = $(this);
				//checking for textbox with other option
				angular.forEach(other_value_validation, function(value, key) {
					if(key == current_obj.attr('name'))
					{
						if(current_obj.val() == '')
						{
							validation_failed['other'] = value['other_error_message'];
						}
						else
						{
							new_form_data.append(key, current_obj.val());
						}
					}
				});

				var current_validation = {};
				angular.forEach($scope.validationAttributes, function(value, key){
					if(value.type == 'textbox' && value.element_name == current_obj.attr('name'))
					{
						current_validation = value;
						return false;//break
					}
				});

				if((current_validation.dependent_element in atleast_one) && (atleast_one[current_validation.dependent_element].indexOf(current_validation.id) != -1)){
					if(current_obj.val() == '')
					{
						validation_failed['select'] = current_validation['error_message'];
					}
					else
					{
						new_form_data.append(current_validation.element_name, current_obj.val());
					}
				}

			}

			if($(this).prop('type') == 'select-one'){
				var current_obj = $(this);
				var current_validation = {};
				angular.forEach($scope.validationAttributes, function(value, key){
					if(value.type == 'select' && value.element_name == current_obj.attr('name'))
					{
						current_validation = value;
						return false;//break
					}
				});

				if((current_validation.dependent_element in atleast_one) && (atleast_one[current_validation.dependent_element].indexOf(current_validation.id) != -1)){
					if(current_obj.val() == '')
					{
						validation_failed['select'] = current_validation['error_message'];
					}
					else
					{
						new_form_data.append(current_validation.element_name, current_obj.val());
					}
				}
			}

			if($(this).attr('type') == 'text'){


				var current_obj = $(this);
				var current_validation = {};
				angular.forEach($scope.validationAttributes, function(value, key){
					if(value.type == 'text' && value.element_name == current_obj.attr('name'))
					{
						current_validation = value;
						return false;//break
					}
				});

				if((current_validation.dependent_element in atleast_one) && (atleast_one[current_validation.dependent_element].indexOf(current_validation.id) != -1)){
					if(current_obj.val() == '')
					{
						validation_failed['datepicker'] = current_validation['error_message'];
					}
					else
					{
						new_form_data.append(current_validation.element_name, current_obj.val());
					}
				}
			}

			if($(this).prop('type') == 'textarea'){
				var current_obj = $(this);
				var current_validation = {};
				angular.forEach($scope.validationAttributes, function(value, key){
					if(value.type == 'textarea' && value.element_name == current_obj.attr('name'))
					{
						current_validation = value;
						return false;//break
					}
				});

				if(current_validation.required == true)
				{
					if(current_obj.val() == '')
					{
						validation_failed['priority_notes'] = current_validation['error_message'];
					}
					else
					{
						new_form_data.append(current_validation.element_name, current_obj.val());
					}
				}
				else
				{
					new_form_data.append(current_validation.element_name, current_obj.val());
				}
			}

			if($(this).prop('type') == 'file'){
				var value = $(this).val();
				if(value != '')
				{
					if(_file_extension.length > 0)
					{
						ext = value.substring(value.lastIndexOf('.') + 1).toLowerCase();
		                if(_file_extension.indexOf(ext) == -1)
		                {
		                	validation_failed['files'] = 'Invalid File Extension. Allowed Extensions are '+_file_extension.join();
		                }
					}

					if(_file_size != '')
					{
						var file_size = $(this)[0]['files'][0].size/1024;
						if(file_size > _file_size)
	                    {
	                    	if(typeof(validation_failed['files']) != 'undefined')
	                    	{
	                    		var allowedSize = _file_size/1024;
	                    		validation_failed['files'] += '. Large file, allowed file size is '+allowedSize.toFixed(2)+' MB';
	                    	}
	                    	else
	                    	{
	                    		var allowedSize = _file_size/1024;
	                    		validation_failed['files'] += 'Large file, allowed file size is '+allowedSize.toFixed(2)+' MB';
	                    	}
	                    }
					}

					if(typeof(validation_failed['files']) == 'undefined')
					{
						new_form_data.append($(this).attr('name'), $(this)[0]['files'][0]);
					}
				}
			}
		    
		});

		//finally checking atleast one condition
		angular.forEach(atleast_one, function(value, key){
			if(value.length < 1)
			{
				validation_failed['atleast_one'] = atleast_one_error_message;
				return false;//break
			}
		});

		// Display the new form data
		/*for (var pair of new_form_data.entries()) {
		    console.log(pair[0]+ ', ' + pair[1]); 
		}*/

		if(Object.keys(validation_failed).length > 0)
		{
			var alert_string = '';
			angular.forEach(validation_failed, function(value, key){
				alert_string += value+'\n';
			});
			alert(alert_string);
			return false;
		}
		else
		{
			var promise = $http({
				url: "action_plan/record_action_plan", 
				data:new_form_data, 
				method: "post", 
				cache: false,
                contentType: false,
                processData: false,
                transformRequest: angular.identity,
				headers: { 'Content-Type': undefined },
				// timeout: canceller.promise, ignoreLoadingBar:hide_loading_bar
			}).then(function (response)
			{
				$scope.action_plan_details = response.data.data;
				alert($scope.action_plan_details.success_message);
				//redirect to current tab based on action status
				$scope.changeTabSelection();
				//end of redirect to current tab based on action status
			});
		}	
	}

	$scope.mark_as_complete = function($plan_id, $details_id)
	{
		actionParams = {};
		actionParams.admin_site_id = $scope['appState']['admin_site_superset_value'];
		actionParams.time_period = $scope['appState']['submit_time_value'];
		actionParams.survey_key = $scope['appState']['submenu_key'];
		actionParams.from_time = $scope['current_time_period_obj']['from'];
		actionParams.to_time = $scope['current_time_period_obj']['to'];
		
		actionParams.plan_id = $plan_id;
		actionParams.details_id = $details_id;

		dataService.getData('action_plan/mark_action_as_complete', actionParams, 'POST')
		.then(function(response) {
			if(typeof(response.data) != 'undefined')
			{
				$scope.action_plan_details = response.data;
				$scope.changeTabSelection();
			}
		})
	}

	$scope.delete_action_plan_document = function($file_id, $priority_id)
	{
		actionParams = {};
		actionParams.file_id = $file_id;
		if (confirm("Are you sure want to delete?")) {
			//$element_to_remove = 'document_'+$priority_id;
   			dataService.getData('action_plan/delete_saved_document', actionParams, 'POST')
			.then(function(response) {
				if(typeof(response.data) != 'undefined')
				{
					if(response.data == true)
					{
						/*console.log($element_to_remove);
						var myEl = angular.element( document.querySelector( '#'+$element_to_remove ) );
						myEl.remove();*/
						$('#file_name_placeholder_'+$priority_id).html('');
						$('#file_name_placeholder_'+$priority_id).hide();
						$('#file_placeholder_'+$priority_id).show();
					}
				}
			})
 		}
	}

	$scope.setFile = function(element, priority_id)
	{
		$scope.$apply(function($scope) {

			var _file_extension = [];
			var _file_size = '';

			if(typeof($scope['action_plan_details']['file_validation']) != 'undefined')
			{
				if(typeof($scope['action_plan_details']['file_validation']['extension']) != 'undefined')
				{
					_file_extension = $scope['action_plan_details']['file_validation']['extension'];
				}
				if(typeof($scope['action_plan_details']['file_validation']['file_size']) != 'undefined')
				{
					_file_size = $scope['action_plan_details']['file_validation']['file_size'];
				}
			}

			if(_file_extension.length > 0)
			{
				var value = element.files[0].name;
				ext = value.substring(value.lastIndexOf('.') + 1).toLowerCase();
                if(_file_extension.indexOf(ext) == -1)
                {
                	alert('Invalid File Extension. Allowed Extensions are '+_file_extension.join());
                	return false;
                }
			}

			if(_file_size != '')
			{
				var file_size = element.files[0].size/1024;
				if(file_size > _file_size)
                {
            		var allowedSize = _file_size/1024;
            		alert('Large file allowed file size is '+allowedSize.toFixed(2)+' MB');
            		return false;
                }
			}


			$('#file_placeholder_'+priority_id).hide();
			var html = '<div syle="text-align:center;">'+element.files[0].name+' <a class="remove_file" data-file_id="'+priority_id+'" href="javascript:void(0)"><i class="fa fa-window-close file" aria-hidden="true"></i></a></div>';
			$('#file_name_placeholder_'+priority_id).html(html);
			$('#file_name_placeholder_'+priority_id).show();
        });
	}

	$scope.removeFile = function(priority_id)
	{
		$('#file_name_placeholder_'+priority_id).html('');
		$('#file_name_placeholder_'+priority_id).hide();
		$('#file_placeholder_'+priority_id).show();
	}

	$('#main-content').on('click','a.action_url', function(e){
		var id = $( this ).data('id');
		var survey_key = $scope.appState['submenu_key'];
		var page = $scope.appState['page'];
		var cx_current_app_url = typeof($location.$$absUrl) != 'undefined' ? $location.$$absUrl : '';
		$scope.$parent.$parent['enable_back_button'] = cx_current_app_url;
		$scope.goToPage(page,{"admin_site_superset_value":id}, survey_key);
		$scope.$apply();
	});

	$scope.$parent.$parent.goBack = function()
	{
		var redirect_url = $scope.enable_back_button;
		var pageText = $scope.appState.page;
		var currentPageDetails = (typeof ($scope.navigation[pageText]) != 'undefined' && typeof ($scope.navigation[pageText].submenu) != 'undefined') ? $scope.navigation[pageText] : null; 
		$.each(currentPageDetails.submenu, function(key, submenu)
		{
			if(typeof (submenu.params) != 'undefined' && typeof (submenu.params.selectedKey) != 'undefined')
			{	
				var submenuKey = submenu.params.selectedKey;
				if(typeof($scope.appState.submenu_key) != 'undefined')
				{
					delete $scope.navigation[pageText]['submenu'][key]['params']['admin_site_superset_value'];
				}	
			}
		});
		$scope.enable_back_button = false;
		$window.location.href = redirect_url;
	}

	$('#main-content').on('click','a.remove_file', function(e){
		var priority_id = $(this).data('file_id');
		if(typeof($(this).data('fid')) != 'undefined')
		{
			var fid = $(this).data('fid');
			$scope.delete_action_plan_document(fid, priority_id);
		}
		else
		{
			$scope.removeFile(priority_id);
		}
	});

	
});
